module.exports = __webpack_public_path__ + "images/instructor-horia-margarit.webp";